import { atom } from 'jotai';

import { EquipmentBrowserViewResponse } from '@repo/sdk/models/components';

/**
 * This is set when we fetch equipment browser information.
 */
export const equipmentBrowserResponseAtom = atom<EquipmentBrowserViewResponse | undefined>(
  undefined
);
equipmentBrowserResponseAtom.debugLabel = 'equipmentBrowserResponseAtom';

export const equipmentBrowserLoadingAtom = atom<boolean>(false);
equipmentBrowserLoadingAtom.debugLabel = 'equipmentBrowserLoadingAtom';
